import { render, staticRenderFns } from "./DividerTitle.vue?vue&type=template&id=5dfb1bba&scoped=true&"
import script from "./DividerTitle.vue?vue&type=script&lang=js&"
export * from "./DividerTitle.vue?vue&type=script&lang=js&"
import style0 from "./DividerTitle.vue?vue&type=style&index=0&id=5dfb1bba&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dfb1bba",
  null
  
)

export default component.exports